var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSafedelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#626366",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    "data-name": "Layer 1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.61,84.17a1.5,1.5,0,0,1-.45-2.93l8.53-2.67a1.5,1.5,0,0,1,.9,2.86L61.06,84.1A1.41,1.41,0,0,1,60.61,84.17Z",
    fill: "#626366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41,90.25a1.46,1.46,0,0,1-1.5-1.46V40a1.49,1.49,0,0,1,1.05-1.43L78.43,26.76a1.52,1.52,0,0,1,1.34.22,1.51,1.51,0,0,1,.61,1.21V51a1.5,1.5,0,0,1-3,0V30.23L42.54,41.13V88.71A1.53,1.53,0,0,1,41,90.25Z",
    fill: "#626366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41,90.29a1.5,1.5,0,0,1-.45-2.93l19.57-6.12a1.5,1.5,0,1,1,.89,2.86L41.49,90.22A1.41,1.41,0,0,1,41,90.29Z",
    fill: "#626366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47,81.29a1.5,1.5,0,0,1-.45-2.93l16.46-5.15a1.5,1.5,0,0,1,1.88,1,1.48,1.48,0,0,1-1,1.87L47.49,81.22A1.41,1.41,0,0,1,47,81.29Z",
    fill: "#626366"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47,74.29a1.5,1.5,0,0,1-.45-2.93l10.53-3.29A1.5,1.5,0,1,1,58,70.93L47.49,74.22A1.41,1.41,0,0,1,47,74.29Z",
    fill: "#626366"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41,90.21a1.35,1.35,0,0,1-.44-.07L2.7,78.3a1.49,1.49,0,0,1-1.06-1.43V28.11a1.5,1.5,0,0,1,1.5-1.5,1.43,1.43,0,0,1,.46.07l10.27,3.2a1.52,1.52,0,0,1,1.05,1.44V51.94a1.52,1.52,0,0,1,.14,1.3,1.5,1.5,0,0,1-1.91.92l-.23-.08a1.51,1.51,0,0,1-1-1.42V32.42L4.64,30.14V75.77l34.9,10.9V41.05L31.36,38.5V58a1.5,1.5,0,0,1-3,0V36.46A1.52,1.52,0,0,1,30.31,35l11.18,3.5a1.48,1.48,0,0,1,1,1.43V88.71a1.48,1.48,0,0,1-.61,1.21A1.5,1.5,0,0,1,41,90.21Z",
    fill: "#626366"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.86,59.53a1.5,1.5,0,0,1-1.5-1.5V36.66a1.59,1.59,0,0,1,.06-.68,1.48,1.48,0,0,1,1.88-1,1.55,1.55,0,0,1,1.06,1.44V58A1.5,1.5,0,0,1,29.86,59.53Z",
    fill: "#626366"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65,54.24a1.74,1.74,0,0,1-.5-.08l-.23-.08a1.51,1.51,0,0,1-1-1.42V31.32a1.5,1.5,0,0,1,3,0V51.94a1.52,1.52,0,0,1,.14,1.3A1.49,1.49,0,0,1,13.65,54.24Z",
    fill: "#626366"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41,41.49A1.47,1.47,0,0,1,39.53,40V40a1.5,1.5,0,0,1,3,0A1.52,1.52,0,0,1,41,41.49Z",
    fill: "#626366"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16,29.6a1.5,1.5,0,0,1-.58-2.88l38-15.82a1.5,1.5,0,1,1,1.15,2.77l-38,15.82A1.44,1.44,0,0,1,3.16,29.6Z",
    fill: "#626366"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.62,32.85A1.5,1.5,0,0,1,14,30l17.17-7.14a1.5,1.5,0,0,1,1.15,2.77L15.19,32.73A1.46,1.46,0,0,1,14.62,32.85Z",
    fill: "#626366"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.83,37.94A1.48,1.48,0,0,1,28.45,37a1.5,1.5,0,0,1,.8-2l15.12-6.29a1.5,1.5,0,0,1,1.16,2.77L30.41,37.83A1.49,1.49,0,0,1,29.83,37.94Z",
    fill: "#626366"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.75,18.66a1.51,1.51,0,0,1-.58-.12L40.62,13.66a1.48,1.48,0,0,1-.8-2,1.5,1.5,0,0,1,2-.8l11.56,4.88a1.5,1.5,0,0,1,.8,2A1.52,1.52,0,0,1,52.75,18.66Z",
    fill: "#626366"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M78.89,29.69a1.51,1.51,0,0,1-.58-.12l-26.14-11a1.5,1.5,0,1,1,1.17-2.76l26.14,11a1.5,1.5,0,0,1-.59,2.88Z",
    fill: "#626366"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.87,59.53a1.51,1.51,0,0,1-1.27-.7l-8-12.55a1.5,1.5,0,1,1,2.52-1.61l8,12.55a1.51,1.51,0,0,1-1.26,2.31Z",
    fill: "#626366"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.65,54.24a1.46,1.46,0,0,1-1.12-.51,1.48,1.48,0,0,1,.13-2.11l8.21-7.27a1.5,1.5,0,0,1,2,2.25l-8.21,7.26A1.45,1.45,0,0,1,13.65,54.24Z",
    fill: "#626366"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45,31.65a1.5,1.5,0,0,1-.62-.13L31.2,25.59a1.5,1.5,0,1,1,1.24-2.73l13.13,5.92A1.5,1.5,0,0,1,45,31.65Z",
    fill: "#626366"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M89.71,93.21H76.86A9.23,9.23,0,0,1,67.64,84V71.14a9.23,9.23,0,0,1,9.22-9.21H89.71a9.23,9.23,0,0,1,9.22,9.21V84A9.23,9.23,0,0,1,89.71,93.21ZM76.86,64.93a6.22,6.22,0,0,0-6.22,6.21V84a6.22,6.22,0,0,0,6.22,6.21H89.71A6.22,6.22,0,0,0,95.93,84V71.14a6.22,6.22,0,0,0-6.22-6.21Z",
    fill: "#626366"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M70.27,68.62a1.5,1.5,0,0,1-1.5-1.5v-6A11.72,11.72,0,0,1,78.64,49.5a11.19,11.19,0,0,1,1.91-.16h4.83A11.8,11.8,0,0,1,97.17,61.13v5.11a1.5,1.5,0,0,1-3,0V61.13a8.8,8.8,0,0,0-8.79-8.79H80.55a8.51,8.51,0,0,0-1.42.12,8.74,8.74,0,0,0-7.36,8.67v6A1.5,1.5,0,0,1,70.27,68.62Z",
    fill: "#626366"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M83.27,82.85a1.5,1.5,0,0,1-1.5-1.5V73.68a1.5,1.5,0,0,1,3,0v7.67A1.5,1.5,0,0,1,83.27,82.85Z",
    fill: "#626366"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafedelivery);
export default __webpack_public_path__ + "static/media/safedelivery.61538802fb23c3ec9336d24240796825.svg";
export { ForwardRef as ReactComponent };